import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Reserve from "@/pages/Reserve";
import Reservation from "@/pages/Reservation";
import Lookup from "@/pages/Lookup";
import Terms from "@/pages/Terms";
import LegalDoc from "@/pages/LegalDoc";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/reserve" element={<Reserve />} />
            <Route path="/r/:id" element={<Reservation />} />
            <Route path="/lookup" element={<Lookup />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<LegalDoc docKey="privacy" />} />
            <Route path="/cookies" element={<LegalDoc docKey="cookies" />} />
            <Route path="/purchase-terms" element={<LegalDoc docKey="purchase-terms" />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" />
      </LanguageProvider>
    </div>
  );
}

export default App;
